module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/hairstyle_02-9bbe8fd26d7689658e91941ebba0be5c.webp";